import { Container } from 'inversify-props';
import TYPES from './types';

// Infrastructure
import LinkSowosWealthDummyRepository from './infrastructure/repositories/link-sowos-wealth-dummy-repository';
import LinkSowosWealthHttpRepository from './infrastructure/repositories/link-sowos-wealth-http-repository';
import LinkGoalsVueStateManager
  from '@/modules/flagship/investor-goal/link-sowos-wealth/infrastructure/state/link-goals-vue-state-manager';

// Application
import CreateLinkSowosWealthCommand from './application/commands/create-link-sowos-wealth-command';
import CreateLinkWealthV2Command from './application/commands/create-link-wealth-v2-command';

// Domain
import { LinkSowosWealthRepository } from './domain/repositories/link-sowos-wealth-repository';
import {
  LinkGoalsWealthStateManager,
} from '@/modules/flagship/investor-goal/link-sowos-wealth/domain/state/link-goals-wealth-state-manager';

export default function setupLinkSowosWealth(container: Container) {
  const withDummies = process.env.VUE_APP_REPOSITORY_MODE === 'dummy';
  container
    .bind<LinkSowosWealthRepository>(
      TYPES.LINK_SOWOS_WEALTH_REPOSITORY,
    ).to(
      withDummies
        ? LinkSowosWealthDummyRepository
        : LinkSowosWealthHttpRepository,
    ).inSingletonScope();

  container
    .bind<CreateLinkSowosWealthCommand>(
      TYPES.CREATE_LINK_SOWOS_WEALTH_COMMAND,
    ).to(CreateLinkSowosWealthCommand)
    .inSingletonScope();

  container
    .bind<CreateLinkWealthV2Command>(
      TYPES.CREATE_LINK_WEALTH_V2_COMMAND,
    ).to(CreateLinkWealthV2Command)
    .inSingletonScope();

  container
    .bind<LinkGoalsWealthStateManager>(
      TYPES.LINK_GOALS_WEALTH_STATE_MANAGER,
    ).to(LinkGoalsVueStateManager)
    .inSingletonScope();
}
